import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { PopupInsideButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import { DropDownButton } from "../../dropDownButtonReusable/DropDownButton";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

export const TableSizePopup = ({
  showPax,
  onOpenModal,
  open,
  onCloseModal,
  table_size,
  onClickAll,
  onClickTwo,
  onClickFour,
  onClickSix,
  onClickEight,
  graterThanEight,
  selectPaxClick,
}) => {
  return (
    <React.Fragment>
      <DropDownButton
        dropDownCss="main-dropdown-section d-flex align-items-center"
        headingText="Pax"
        divClass="insidedropdown-div"
        insideText={showPax}
        displayDropDown=""
        onClick={onOpenModal}
      />
      {/* <PopupActionButton
          buttonText={this.props.buttonText}
          buttonType="button"
          buttonClass="cancel"
          onClick={this.onOpenModal}
        /> */}
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="reusable-popup-header-newstyle">
          <h4 className="c-black font_24_b">Party Size</h4>
        </div>
        <div className="">
          <div className="f18-500 text-left my-3 my-md-5">
            Select one relevant option from below
          </div>
          <div className="row">
            <div className="col-6 col-md-4">
              {/* mb-4 */}
              <PopupInsideButton
                buttonClass={
                  table_size === "All"
                    ? "status-selected-button-box f15-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f15-500"
                }
                buttonText="All"
                buttonType="button"
                onClick={onClickAll}
              />
            </div>
            <div className="col-6 col-md-4">
              {/* mb-4 */}
              <PopupInsideButton
                buttonClass={
                  table_size === "2"
                    ? "status-selected-button-box f15-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f15-500"
                }
                buttonText="0 - 2 Pax"
                buttonType="button"
                onClick={onClickTwo}
              />
            </div>
            <div className="col-6 col-md-4">
              {/* mb-4 */}
              <PopupInsideButton
                buttonClass={
                  table_size === "4"
                    ? "status-selected-button-box f15-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f15-500"
                }
                buttonText="3 - 4 Pax"
                buttonType="button"
                onClick={onClickFour}
              />
            </div>
            <div className="col-6 col-md-4">
              {/* mb-4 */}
              <PopupInsideButton
                buttonClass={
                  table_size === "6"
                    ? "status-selected-button-box f15-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f15-500"
                }
                buttonText="5 - 6 Pax"
                buttonType="button"
                onClick={onClickSix}
              />
            </div>
            <div className="col-6 col-md-4">
              {/* mb-4 */}
              <PopupInsideButton
                buttonClass={
                  table_size === "8"
                    ? "status-selected-button-box f15-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f15-500"
                }
                buttonText="7 - 8 Pax"
                buttonType="button"
                onClick={onClickEight}
              />
            </div>
            <div className="col-6 col-md-4">
              {/* mb-4 */}
              <PopupInsideButton
                buttonClass={
                  table_size === "8>"
                    ? "status-selected-button-box f15-500 sts_sld_btn_box_a"
                    : "status-selected-button-box f15-500"
                }
                buttonText="8 + Pax"
                buttonType="button"
                onClick={graterThanEight}
              />
            </div>
          </div>
          <div className="mt-5 d-flex">
            <ReusableOnboardingButton
              buttonTitle="Cancel Button"
              buttonClass={
                "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              }
              buttonText="Cancel"
              onClick={onCloseModal}
              buttonType="button"
            />
            <ReusableOnboardingButton
              buttonTitle="Confirm Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              buttonText="Confirm"
              onClick={selectPaxClick}
              buttonType="button"
            />
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default TableSizePopup;
